<template>
  <NewOrderModal
    v-if="showOrderModal"
    :open="showOrderModal"
    :table-id="selectedTableForOrder ? selectedTableForOrder.id : null"
    :mode="orderModalMode"
    :order-to-edit="orderToEdit"
    @close="emit('close-order-modal')"
    @order-created="emit('order-created')"
  />

  <OrderDetailsModal
    v-if="showOrderDetailsModal"
    :open="showOrderDetailsModal"
    :order="selectedOrderForDetails || {}"
    @close="emit('close-order-details-modal')"
    @status-update="emit('order-status-update')"
    @payment-completed="emit('payment-completed')"
  />
</template>

<script setup lang="ts">
import NewOrderModal from '@/components/orders/NewOrderModal.vue';
import OrderDetailsModal from '@/components/orders/OrderDetailsModal.vue';
import type { Table } from '@/services/tableService';
import type { Order } from '@/services/orderService';

defineProps<{
  showOrderModal: boolean;
  selectedTableForOrder: Table | null;
  orderModalMode: 'create' | 'edit';
  orderToEdit: Order | null;
  showOrderDetailsModal: boolean;
  selectedOrderForDetails: Order | null;
}>();

const emit = defineEmits<{
  (e: 'close-order-modal'): void;
  (e: 'order-created'): void;
  (e: 'close-order-details-modal'): void;
  (e: 'order-status-update'): void;
  (e: 'payment-completed'): void;
}>();
</script>
